import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import axios from '@/services/axios'
import router from '@/router'

const store = createStore({
  plugins: [
    createPersistedState()
  ],
  state: {
    authenticated: false,
    user: null,
    token: null,
    role: null,
    app: {
      name: 'ระบบบริหารจักการผู้ใช้',
      name_en: 'USER HOS WNH'
    }
  },
  mutations: {
    authenticateUser(state, data) {
      const token = data.token || data.access_token || data.data?.token;
      const user = data.user || data.data?.user || data.data || null;
      const role = data.role || data.user?.role || data.data?.role || data.data?.user?.role || null;

      state.authenticated = true;
      state.token = token;
      state.user = user;
      state.role = role;
    },
    unauthenticateUser(state) {
      state.authenticated = false;
      state.token = null;
      state.user = null
      state.role = null
    },
  },
  actions: {
    async startSsoLogin() {
      const res = await axios.get('sso/redirect');
      const authorizeUrl = res.data?.authorize_url;

      if (!authorizeUrl) {
        throw new Error('SSO authorize URL not found.');
      }

      window.location.href = authorizeUrl;
    },
    async ssoLogin({ commit }, payload) {
      const res = await axios.post('sso/login', payload);
      commit('authenticateUser', res.data);

      const token = res.data.token || res.data.access_token || res.data.data?.token;
      const role = res.data.role || res.data.user?.role || res.data.data?.role || res.data.data?.user?.role || null;

      if (token) {
        localStorage.setItem('token', token);
      }
      if (role) {
        localStorage.setItem('role', role);
      }

      await router.replace({ name: 'dashboard' });
    },
    async login({ commit }, credentials) {
      const login = String(credentials.login || credentials.username || '').trim();
      const payload = new URLSearchParams();
      payload.append('login', login);
      payload.append('password', credentials.password);
      payload.append('device_name', credentials.device_name || process.env.VUE_APP_DEVICE || 'mdr');

      const res = await axios.post('login', payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      commit('authenticateUser', res.data)

      const token = res.data.token || res.data.access_token || res.data.data?.token;
      const role = res.data.role || res.data.user?.role || res.data.data?.role || res.data.data?.user?.role || null;

      if (token) {
        localStorage.setItem('token', token)
      }
      if (role) {
        localStorage.setItem('role', role)
      }

      await router.push({ name: 'dashboard' })
    },
    async logout({ commit }) {
      try {
        await axios.post('logout');
      } catch (error) {
        // Local logout should still complete if the token is already expired.
      }
      commit('unauthenticateUser');
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      await router.push({ name: 'login' })
    },

  },
  getters: {
    isAuthenticated(state) {
      return state.authenticated || Boolean(state.token || localStorage.getItem('token'));
    },
    user(state) {
      return state.user;
    },
    userToken(state) {
      return state.token || localStorage.getItem('token');
    }
  },
})

export default store
 
